import axios from 'axios';
const API_URL = `${process.env.REACT_APP_API_URL}/api` // Laravel backend URL

const api = axios.create({
  baseURL: API_URL,
  headers: { 'Accept': 'application/json' },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('userToken');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default api;
